import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import {
  Facebook,
  Email,
  Phone,
  LocationOn,
} from '@mui/icons-material';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleLinkClick = (e: React.MouseEvent<HTMLElement>, path: string) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Golden Books
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Вашата доверена онлайн книжарница за всички жанрове. Открийте следващата си страхотна книга днес.
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton
                aria-label="facebook"
                color="primary"
                component="a"
                href="https://www.facebook.com/goldenbooks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Бързи връзки
            </Typography>
            <Link 
              href="/shop" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/shop')}
            >
              Магазин
            </Link>
            <Link 
              href="/legal/contact" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/contact')}
            >
              Контакти
            </Link>
            <Link 
              href="/legal/delivery" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/delivery')}
            >
              Доставка
            </Link>
            <Link 
              href="/legal/returns" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/returns')}
            >
              Връщания
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Правна информация
            </Typography>
            <Link 
              href="/legal/terms" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/terms')}
            >
              Общи условия
            </Link>
            <Link 
              href="/legal/privacy" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/privacy')}
            >
              Политика за поверителност
            </Link>
            <Link 
              href="/legal/cookies" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/cookies')}
            >
              Политика за cookies
            </Link>
            <Link 
              href="/legal/returns" 
              color="text.secondary" 
              display="block" 
              sx={{ mb: 1, cursor: 'pointer' }}
              onClick={(e) => handleLinkClick(e, '/legal/returns')}
            >
              Политика за връщане
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Информация за контакт
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Email sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2" color="text.secondary">
                info@goldenbooks.bg
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Phone sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2" color="text.secondary">
                0895628293
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
              <LocationOn sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2" color="text.secondary">
                София, България<br />
                „Голдън Букс" ЕООД
              </Typography>
            </Box>
          </Grid>
        </Grid>
        
        <Box sx={{ mt: 5, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} „Голдън Букс" ЕООД. Всички права запазени.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;